module.exports = __webpack_public_path__ + "img/ic_food_asian.3aeb9b7c.png";